import React from 'react';
import EventEmitter from '../../../utils/emmiter';
import {UserContext} from '../../../utils/usercontext';
import {useracc, postApi} from '../../../utils/functions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './platforms.css'

export default class EmbedPlatforms extends React.Component {
	static contextType = UserContext;
  constructor(props) {
		super(props);
		this.state = {
			service: {
				status: false,
				id: props.service.service || props.service.id,
				name: '',
			},
      platforms: [],

      ListenerEmbeds: null,
		};
    this.getPlatforms = this.getPlatforms.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
	}

	async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
    const y = await value.setWorker( this.state.service.id );
		EventEmitter.emit('/client', y);
    
    const ListenerEmbeds = EventEmitter.addListener(`/service/embeds`, async data => {
			if( data.service === this.state.service.id ) await this.getPlatforms();
		}); this.setState({ListenerEmbeds});

    this.getPlatforms();
	}

  componentWillUnmount() {
		if( this.state.ListenerEmbeds ) this.state.ListenerEmbeds.remove();
	}

  async getPlatforms() {
    const value = this.context;
    let params2 = new URLSearchParams();
		params2.append('service', this.state.service.id);
		const z = await postApi(`${value.worker[this.state.service.id]}/v3/embed/platforms`, params2);
    if( z.status === 200 ) {
      document.documentElement.style.setProperty('--embed-default', z.data.profile.embed_color);
      if( z.data.profile.embed_darkmode === 'true' ) {
				document.documentElement.style.setProperty('--embed-dark-1', '#ffffff');
				document.documentElement.style.setProperty('--embed-dark-2', '#F6F6F6');
			} else {
				document.documentElement.style.setProperty('--embed-dark-1', '#000000');
				document.documentElement.style.setProperty('--embed-dark-2', '#090909');
			}
			this.setState({platforms: []},async ()=>{
				this.setState({platforms: z.data.platforms}, ()=>{
					this.updateDimensions();
				});
			});
		}
  }

  async updateDimensions(e) {
		window.parent.postMessage({url: window.location.pathname, height: document.body.scrollHeight}, '*');
	}
  
	render() {
    const platforms = this.state.platforms.map((e,i) => {
			return (
				<Col key={i}  className="embed-platforms-object mx-1 my-auto text-center">
          <a href={e.website} target="_blank" rel="noreferrer">
            <Row className="gx-0">
              <div className="embed-platforms-object-play" style={{width: 70}}>
                <FontAwesomeIcon icon={['far', 'circle-play']} size="xl" />
              </div>
              <Col className={`embed-platforms-${e.platform} embed-platforms-panel`} >
                {e.platform === 'audio' ?
                  <FontAwesomeIcon icon={'headphones'} size="xl" />
                :
                  <img src={`https://cloud.ultrastream.io/images/platforms/${e.platform.toLowerCase()}.png`} width={42} alt="Platform Avatar" />
                }
                <div className="embed-platforms-object-username">
                  <span>{e.username}</span>
                </div>
              </Col>
            </Row>
          </a>
				</Col>
			)
		});
    
		return (
			<Row className="gx-0 pt-4">
        <Col xs={12}>
          <h5 className="embed-platforms-live">
            <span>Watch Live</span>
          </h5>
        </Col>
        <Col xs={12}>
          <Row className="gx-0 d-flex justify-content-center">
            {platforms}
          </Row>
        </Col>
      </Row>
		)
	}
}
